export interface IMember {
  id?: number;
  acs: boolean; //empty or ACS
  divc: boolean; //empty or DivCHED
  teacher: string;
  first: string;
  last: string;
  institution: string;
  addr1: string;
  addr2: string;
  city: string;
  st: string;
  zip: string;
  phone: string;
  email: string;
  username1: string;
  psw?: string;
  password?:string;
  password_confirmation?:string;
  hash?: string;
  weblist: boolean; //yes or no on database
  emailconsent: boolean; //yes or no on database
  expires: number; // year only
  other: string;
  extra3: string;
  admin?: boolean;
  payby?:string;
  amount?:number;
}

export class Member implements IMember{
  acs: boolean = false;
  divc: boolean = false;
  teacher: string = "";
  first: string = "";
  last: string = "";
  institution: string = "";
  addr1: string = "";
  addr2: string = "";
  city: string = "";
  st: string = "";
  zip: string = "";
  phone: string = "";
  email: string = "";
  username1: string = "";
  emailconsent: boolean = true;
  weblist: boolean = true;
  other: string = "";
  expires: number = -1;
  extra3: string = "";
  payby: string = 'check';
  amount: number=0;
}

export type IMemberInfo = Omit<
  IMember,
  "psw" | "hash" | "admin" | "expires" | "extra3" | "member"
>;

export class MemberForm implements IMemberInfo {
  acs: boolean = false;
  divc: boolean = false;
  teacher: string = "";
  first: string = "";
  last: string = "";
  institution: string = "";
  addr1: string = "";
  addr2: string = "";
  city: string = "";
  st: string = "";
  zip: string = "";
  phone: string = "";
  email: string = "";
  username1: string = "";
  emailconsent: boolean = true;
  weblist: boolean = true;
  other: string = "";
  

  constructor() {}
}
